import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { ServiceModule } from 'src/app/services.module/services.module';
import { ElementsModule } from 'src/app/elements.component.module/elements.module';
import { PipeModule } from 'src/app/pipes.module/pipes.module';
import { ModelModule } from 'src/app/model.module/model.module';

@NgModule({
    declarations: [],
    exports: [],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ServiceModule,
        ElementsModule,
        PipeModule,
        ModelModule
    ],
    providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())]
})
export class SharedModule {
    static forRoot(config = null): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: []
        };
    }
}
